import { render } from "./FeedType.vue?vue&type=template&id=177d726b"
import script from "./FeedType.vue?vue&type=script&lang=js"
export * from "./FeedType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__